import React from 'react';
import { Outlet } from 'react-router-dom';

// GPP books are a pharmacy concern — clinic tenants don't keep them, so the SOP
// subtree should ultimately be gated to non-clinic tenants (mirrors HkdBooksGuard's
// gate-and-Outlet shape).
// TODO: re-enable the pharmacy gate once tenant.type is confirmed populated on
// develop — redirect clinics to /dashboard via useTenant +
// `tenant?.type === TENANT_TYPE.CLINIC`. Open access for now.
function SopGuard() {
  return <Outlet />;
}

export default SopGuard;
